export default __webpack_public_path__ + "static/media/download.4b3adbd1.jpg";